import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card";
import SoftTypography from "components/SoftTypography";
import React from "react";
import moment from "moment";
import StatusBadge from "cxfcomponents/StatusBadge";
import useThemeDetector from "hooks/useThemeDetector";

const Tiles = ({ rows }) => {
  const { isDarkMode } = useThemeDetector();

  return (
    <SoftBox
      display="grid"
      sx={{
        gridTemplateColumns: "repeat(auto-fill, minmax(410px, 1fr))",
        gap: 1,
        justifyContent: "start",
        alignItems: "stretch",
        mb: 2
      }}
    >
      {rows.map((row) => (
        <Card
          key={row.id}
          sx={{
            width: "100%",
            minWidth: "373px",
            height: "100%",
            boxShadow: isDarkMode ? "0px 20px 27px rgba(0, 0, 0, 0.05)" : "none",
            margin: "0 auto",
            padding: 3,
          }}
        >
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                flexShrink: 0,
                // padding: "12px",
                height: {
                  xs: "64px",
                  sm: "64px",
                  lg: "94px",
                },
                width: {
                  xs: "64px",
                  sm: "64px",
                  lg: "94px",
                },
              }}
            >
              {row.values?.icon}
            </SoftBox>
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "start",
                width: "100%",
              }}
              ml={3}
              mt={1}
              lineHeight={0}
            >
              <SoftBox
                sx={{
                  display: "flex",
                  alignItems: "start",
                  lineHeight: "0",
                  marginRight: "8px",
                }}
              >
                <SoftBox>
                  <SoftTypography
                    className="white-to-dark"
                    variant="h3"
                    fontWeight="bold"
                    marginBottom="2px"
                    fontSize="14px"
                  >
                    {row.values?.integration_name}
                  </SoftTypography>
                  <StatusBadge status={row.values?.status} />
                  <SoftTypography marginTop="16px" fontSize="14px" sx={{ color: "#A5ADC1" }}>
                    Current Version: {row.values?.current_version}
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
              <SoftBox sx={{ marginLeft: "auto" }}>
                {React.cloneElement(row.values?.action, { isVertical: true })}
              </SoftBox>
            </SoftBox>
          </SoftBox>
          <SoftBox
            className="browse-tiles-divider"
            sx={{
              height: "1px",
              backgroundColor: "#E0E1E2",
              marginTop: "24px",
              marginBottom: "20px",
            }}
          />
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <SoftTypography marginLeft="auto" sx={{ fontSize: "10px" }}>
              <span style={{ fontWeight: 500, fontSize: "12px" }}>Last Edited:</span>
              <span style={{ display: "inline-flex", flexDirection: "column", marginLeft: "8px" }}>
                <span>
                  {row.values?.created_date_time &&
                    moment(row.values?.created_date_time).format("MM/DD/YY")}
                </span>
                <span style={{ lineHeight: 1 }}>
                  {row.values?.created_date_time &&
                    moment(row.values?.created_date_time).format("h:mm:ss A")}
                </span>
              </span>
            </SoftTypography>
          </SoftBox>
        </Card>
      ))}
    </SoftBox>
  );
};

export default Tiles;
